<template lang="html">
  <div class="columns">
    <div class="column">
      <AppNavbar></AppNavbar>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import AppNavbar from '@/components/Navbar'
import AppUsersList from './UsersList'
import AppUsersAddEdit from './UsersAddEdit'
export default {
  name: 'AppUsers',
  components: {
    AppNavbar,
    AppUsersList,
    AppUsersAddEdit
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// UsersMain.vue?3bea6464